import { AxiosInstance, AxiosResponse } from 'axios';

export interface ThirdPartyPort {
  id: string;
  tenantId: string;
  providerId: string;
  linkId: string;
  clientName?: string;
  projectId: string;
  linkType: string;
  purchaseOrder: string;
  projectName: string;
  origin: string;
  destination: string | null;
  capacity: string;
  vendorServiceReference: string;
  contractStartDate: string;
  contractEndDate: string;
  contractStatus: string;
  carrier: string;
  localLoop: string | null;
  lastStatusUpdate: string;
  createdAt: string;
  updatedAt: string;
}

const BASE_URL = '/resource-manager/third-party-ports';

export function getAllThirdPartyPortsAdmin(
    api: AxiosInstance,
): Promise<AxiosResponse> {
    return api.get(`${BASE_URL}/admin/all?`);
}

export function getAllThirdPartyPortsByTenantId(
  api: AxiosInstance,
  tenantId: string
): Promise<AxiosResponse> {
  return api.get(`/?tenantId=${tenantId}`);
}

export function getThirdPartyPortDetails(
  api: AxiosInstance,
  id: string,
  tenantId: string
): Promise<AxiosResponse> {
  return api.get(`${BASE_URL}/${id}?tenantId=${tenantId}`);
}

export function updateThirdPartyPort(
  api: AxiosInstance,
  id: string,
  tenantId: string,
  payload: Partial<ThirdPartyPort>
): Promise<AxiosResponse> {
  return api.put(`${BASE_URL}/${id}?tenantId=${tenantId}`, payload);
}

export function createThirdPartyPort(
  api: AxiosInstance,
  payload: Partial<ThirdPartyPort>
): Promise<AxiosResponse> {
  return api.post(`${BASE_URL}`, payload);
}

export function deleteThirdPartyPort(
  api: AxiosInstance,
  id: string,
): Promise<AxiosResponse> {
  return api.delete(`${BASE_URL}/${id}`);
}